import styled from '@emotion/styled';

export const Container = styled.div`
  .ant-select {
    width: 100%;
  }
  .ant-upload-list-item .anticon-close {
    font-size: 16px;
  }
`;